import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { IInquiryListPlaceholderProps } from './InquiryListPlaceholder.interface';

import './style.scss';

const InquiryListPlaceholder: FC<IInquiryListPlaceholderProps> = ({ className, isComplete }) => {
  const { t } = useTranslation();

  return (
    <div className={cn('inquiry-list-placeholder', className)}>
      <img
        className="inquiry-list-placeholder__icon"
        src={isComplete ? '/images/img-complete.svg' : '/images/img-inprogress.svg'}
      />
      <div
        className={cn('inquiry-list-placeholder__text', {
          'inquiry-list-placeholder__text--complete': isComplete,
        })}
      >
        {isComplete
          ? t('inquiries.completeListPlaceholder')
          : t('inquiries.inProgressListPlaceholder')}
      </div>
    </div>
  );
};

export default InquiryListPlaceholder;
